import { Routes } from '@angular/router';

import { PropertyFinderComponent } from './property-finder.component';

export const propertyFinderRoutes: Routes = [
  {
    path: 'property-finder',
    component: PropertyFinderComponent,
    data: { title: 'property finder' },
  },
];
